export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    headerAlign: 'center',
    align: 'center',
    fixed: 'right',
    width: 110,
    visible: !that.disabled,
    slots: {
      default: 'opt',
    },
  },
  {
    title: that.$l('form_label_funcID') || '功能编号',
    field: 'funcID',
    width: 200,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('form_label_buttonID') || '按钮编号',
    field: 'buttonID',
    width: 150,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('form_label_eventName') || '按钮对应事件',
    field: 'eventName',
    width: 150,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('form_label_displayText') || '按钮显示文字',
    field: 'displayText',
    width: 200,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('form_label_enText') || '英文名称',
    field: 'enText',
    width: 200,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('form_label_buttonImage') || '按钮颜色及图片',
    field: 'buttonImage',
    width: 200,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
    slots: {
      default: 'buttonImage',
    },
  },
  {
    title: that.$l('form_label_modalsPageName') || '按钮位置页面',
    field: 'modalsPageName',
    width: 110,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('form_label_isVisible') || '是否可见',
    field: 'isVisible',
    width: 110,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
    slots: {
      default: 'isVisible',
    },
  },
  {
    title: that.$l('form_label_sortOrder') || '按钮顺序',
    field: 'sortOrder',
    width: 110,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    field: 'creationTime',
    title: that.$l('INDEX.create_date') || '创建时间',
    align: 'center',
    width: 170,
    showHeaderOverflow: true,
    showOverflow: true,
  }
]
